import { __ } from '@wordpress/i18n';
import { 
    BaseControl,
    Button,
    ButtonGroup,
    TextControl,
    Dropdown,
    MenuGroup,
    MenuItem
} from '@wordpress/components';
import { useState, useRef } from '@wordpress/element';
import { Icons } from '../../utils/icons';
// import './style.scss';

const DeviceIcon = ({ type }) => {
    switch (type) {
        case 'desktop':
            return (
                Icons.desktop
            );
        case 'tablet':
            return (
                Icons.tablet
            );
        case 'mobile':
            return (
                Icons.mobile
            );
        default:
            return null;
    }
};

const Spacing = ({ value = {}, onChange, label = __('Boşluk', 'kan') }) => {
    const [activeDevice, setActiveDevice] = useState('desktop');
    const [isLinked, setIsLinked] = useState(true);
    const dropdownRef = useRef();

    const devices = [
        { name: 'desktop', label: __('Masaüstü', 'kan') },
        { name: 'tablet', label: __('Tablet', 'kan') },
        { name: 'mobile', label: __('Mobil', 'kan') }
    ];

    const edges = [
        { name: 'top', label: __('Üst', 'kan') },
        { name: 'right', label: __('Sağ', 'kan') },
        { name: 'bottom', label: __('Alt', 'kan') },
        { name: 'left', label: __('Sol', 'kan') }
    ];

    const updateValue = (edge, newValue) => {
        const numValue = parseInt(newValue) || 0;
        
        if (isLinked) {
            onChange({
                ...value,
                [activeDevice]: {
                    ...(value[activeDevice] || {}),
                    top: numValue,
                    right: numValue,
                    bottom: numValue,
                    left: numValue
                }
            });
        } else {
            onChange({
                ...value,
                [activeDevice]: {
                    ...(value[activeDevice] || {}),
                    [edge]: numValue
                }
            });
        }
    };

    const getCurrentValue = (edge) => {
        if (!value[activeDevice]) return '';
        return value[activeDevice][edge] || '';
    };

    const resetValue = () => {
        onChange({});
    };

    const handleDeviceChange = (device) => {
        setActiveDevice(device);
        if (dropdownRef.current) {
            dropdownRef.current.toggle();
        }
    };

    return (
        <BaseControl className="kan-control-item kan-spacing-control">
            <div className="kan-control-header">
                <span className="kan-control-label">{label}</span>
                <div className="kan-control-actions">
                    <Dropdown
                        ref={dropdownRef}
                        className="kan-device-dropdown"
                        contentClassName="kan-device-dropdown-content"
                        position="bottom right"
                        renderToggle={({ isOpen, onToggle }) => (
                            <Button
                                onClick={onToggle}
                                aria-expanded={isOpen}
                                className="kan-device-button"
                            >
                                <DeviceIcon type={activeDevice} />
                            </Button>
                        )}
                        renderContent={() => (
                            <MenuGroup>
                                {devices.map(device => (
                                    <MenuItem
                                        key={device.name}
                                        onClick={() => handleDeviceChange(device.name)}
                                        isSelected={activeDevice === device.name}
                                    >
                                        <DeviceIcon type={device.name} />
                                        <span>{device.label}</span>
                                    </MenuItem>
                                ))}
                            </MenuGroup>
                        )}
                    />
                    <Button
                        isSmall
                        isSecondary
                        onClick={resetValue}
                        className="kan-reset-button"
                        icon="image-rotate"
                    />
                </div>
            </div>

            <div className="kan-control-inputs">
                <div className="kan-control-box">
                    {edges.map(edge => (
                        <div key={edge.name} className="kan-control-field">
                            <TextControl
                                type="number"
                                className={`kan-control-input kan-control-${edge.name}`}
                                value={getCurrentValue(edge.name)}
                                onChange={(value) => updateValue(edge.name, value)}
                            />
                            <span className="kan-control-label">{edge.label}</span>
                        </div>
                    ))}
                    <Button
                        className="kan-control-link"
                        isPrimary={isLinked}
                        onClick={() => setIsLinked(!isLinked)}
                        icon={isLinked ? 'admin-links' : 'editor-unlink'}
                    />
                </div>
            </div>
        </BaseControl>
    );
};

export default Spacing; 